/**
 * Per-layer weather: Mind flickers, Heart turns slowly, Will is the door.
 * Thresholds are tilt (−100 Truth … +100 Lie).
 */
import type { LayerId } from "./types";

export type LayerTiltBand = {
  /** Lies may start a push toward the next layer */
  lieStrong: number;
  /** Marching copies / inward multiply */
  lieMarch: number;
  /** Overflow starts shoving the next layer inward */
  overflow: number;
  /** Packed overflow wears prayers on the next layer */
  overflowCrush: number;
  /** Path prayer can walk when the row is contested */
  prayerAdvance: number;
  /** Truth overflow starts blessing the layer outward */
  truthOverflow: number;
  /** Empty-row settle speed toward 0 (tilt units / sec) */
  settle: number;
};

export const LAYER_TILT: Record<LayerId, LayerTiltBand> = {
  mind: {
    lieStrong: 16,
    lieMarch: 10,
    overflow: 12,
    overflowCrush: 28,
    prayerAdvance: -10,
    truthOverflow: -22,
    settle: 14,
  },
  heart: {
    lieStrong: 28,
    lieMarch: 20,
    overflow: 24,
    overflowCrush: 40,
    prayerAdvance: -18,
    truthOverflow: -36,
    settle: 7,
  },
  will: {
    lieStrong: 40,
    lieMarch: 28,
    overflow: 35,
    overflowCrush: 50,
    prayerAdvance: -22,
    truthOverflow: -45,
    settle: 4,
  },
};

export function tiltBand(layer: LayerId): LayerTiltBand {
  return LAYER_TILT[layer];
}
